module.exports = __webpack_public_path__ + "img/erath.b8d702cd.webp";